import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssIconComponent } from '../icon/icon.component';
import {
  UMSS_CLOSE_OVERLAY,
  UmssOverlayCloseable
} from '../overlay-base/overlay-base.directive';

@Component({
  selector: 'umss-dialog-header',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss']
})
export class UmssDialogHeaderComponent {
  @HostBinding('style.display') display = 'contents';

  private readonly overlayCloseable = inject<UmssOverlayCloseable>(
    UMSS_CLOSE_OVERLAY,
    { optional: true }
  );

  /** Content props */
  @Input() title: string = '';
  @Input() subtitle?: string;
  @Input() showCloseButton: boolean = true;
  @Input() showBackButton: boolean = false;
  /** Variant props */
  @Input() type = 'Header';
  /** Style props */
  @Input() dialogHeaderAlignSelf: string | number = '';
  @Input() dialogHeaderWidth: string | number = '';
  @Input() dialogHeaderHeight: string | number = '';

  /** Events */
  @Output() onClose = new EventEmitter<void>();
  @Output() onBack = new EventEmitter<void>();

  handleCloseClick() {
    if (this.overlayCloseable) this.overlayCloseable.handleClose();
    else this.onClose.emit();
  }

  handleBackClick() {
    this.onBack.emit();
  }

  get dialogHeaderStyle() {
    return {
      'align-self': this.dialogHeaderAlignSelf,
      width: this.dialogHeaderWidth,
      height: this.dialogHeaderHeight
    };
  }
}
